function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.506 9.287c-1.521 0-2.755-1.603-2.755-3.581s1.233-3.581 2.755-3.581c1.521 0 2.755 1.603 2.755 3.581s-1.234 3.581-2.755 3.581zM22.463 30.549c-1.34 0-2.634-.483-3.711-1.4l-.358-.307C17.3 27.9 16.877 27.574 16 27.574c-.877 0-1.3.326-2.394 1.269l-.358.307c-1.288 1.098-2.886 1.571-4.5 1.345-1.679-.238-3.152-1.2-4.15-2.709-1.943-2.94-1.403-7.137 1.204-9.354l7.446-6.336c1.619-1.379 3.885-1.379 5.504 0l7.446 6.336c2.607 2.218 3.147 6.414 1.204 9.354-.997 1.509-2.471 2.471-4.149 2.709a5.86 5.86 0 0 1-.79.054zM16 25.074c1.851 0 2.858.868 4.025 1.874l.346.297c.735.626 1.638.901 2.53.773.961-.136 1.818-.709 2.415-1.612 1.271-1.921.939-4.645-.737-6.071l-7.446-6.336c-.689-.586-1.576-.586-2.266 0l-7.446 6.336c-1.677 1.427-2.008 4.15-.737 6.071.598.903 1.455 1.477 2.415 1.612.896.127 1.793-.147 2.53-.773l.346-.297c1.167-1.006 2.174-1.874 4.025-1.874zM17.739 5.706c0 1.978 1.234 3.581 2.755 3.581s2.755-1.603 2.755-3.581-1.234-3.581-2.755-3.581c-1.522 0-2.755 1.603-2.755 3.581zm9.734 8.718c-1.381 0-2.5-1.357-2.5-3.03 0-1.673 1.119-3.03 2.5-3.03s2.5 1.357 2.5 3.03c0 1.673-1.119 3.03-2.5 3.03zM2.02 11.394c0 1.673 1.119 3.03 2.5 3.03s2.5-1.357 2.5-3.03c0-1.673-1.119-3.03-2.5-3.03s-2.5 1.357-2.5 3.03z"
});

var SvgPets = function SvgPets(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "f503d4917ed92ee971879886cae72b80.svg";
export { SvgPets as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/pets.svg
// module id = null
// module chunks = 